'use strict';

const BaseModel = require('./base');

class DateModel extends BaseModel {
  constructor() {
    super(...arguments);
    if (this.isDate()) {
      let [year, month, date] = this.get('originalDate').split('-');
      year = Number(year);
      month = Number(month) - 1;
      date = Number(date);

      this.set({
        year,
        month,
        date,
      });
    }
  }

  toString() {
    return this.get('originalDate');
  }

  isEqual(otherDate) {
    return this.toString() === otherDate.toString();
  }

  getMonth() {
    if (this.isDate()) {
      return this.get('month');
    } else {
      throw new Error('Month is not supported for this type');
    }
  }

  getYear() {
    if (this.isDate()) {
      return this.get('year');
    } else {
      throw new Error('Year is not supported for this type');
    }
  }

  isDate() {
    const validDateRegex = /^\d{4}-\d{2}-\d{2}$/;
    return validDateRegex.test(this.get('originalDate'));
  }
}

module.exports = DateModel;
